// extracted by mini-css-extract-plugin
export default {"thumbnail":"K6IiW19HTo","stats":"MSbkbKpNF0","location":"n4_2Irjek4"};